import { render, staticRenderFns } from "./YourLinkMobile.vue?vue&type=template&id=1b45d044"
import script from "./YourLinkMobile.vue?vue&type=script&lang=js"
export * from "./YourLinkMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports